
import React from 'react';
import * as LucideIcons from 'lucide-react';

const VibeOrb = ({ vibeScore }) => {
  const clampedScore = Math.max(0, Math.min(100, vibeScore));

  const getColor = () => {
    if (clampedScore > 75) return 'bg-green-500'; // High Vibe
    if (clampedScore > 50) return 'bg-blue-500';  // Good Vibe
    if (clampedScore > 25) return 'bg-yellow-500'; // Neutral Vibe
    return 'bg-red-500'; // Low Vibe
  };

  const getPulseIntensity = () => {
    if (clampedScore > 75) return 'animate-pulse-fast';
    if (clampedScore > 50) return 'animate-pulse-normal';
    if (clampedScore > 25) return 'animate-pulse-slow';
    return 'animate-pulse-none'; // No pulse for low vibe
  };

  return (
    <div className="relative w-8 h-8 rounded-full flex items-center justify-center">
      <div className={`w-full h-full rounded-full ${getColor()} ${getPulseIntensity()} opacity-70`}></div>
      <LucideIcons.Smile size={16} className="absolute text-white" />
    </div>
  );
};

export default VibeOrb;
